export default {
	FEEDING_LIST: {
		key: 'FEEDING_LIST',
		defaultValue: {
			data: [],
			meta: { total_itens: 0 }
		}
	},
	FEEDING_DELETION: {
		key: 'FEEDING_DELETION',
		defaultValue: {}
	}
	,
	FEEDING_ITEM: {
		key: 'FEEDING_ITEM',
		defaultValue: {}
	},
	FEEDING_ITEM_SAVE: {
		key: 'FEEDING_ITEM_SAVE',
		defaultValue: {}
	},
	FEED_LIST: {
		key: 'FEED_LIST',
		defaultValue: {
			data: [],
			meta: { total_itens: 0 }
		}
	}
};